import { AllNotificationType, OrderNotification } from '@tradingblock/types';

export function isOrderNotification(not: AllNotificationType): not is OrderNotification {
  return not.type === 'Order';
}
